'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _BaseContentCardPaywall = require('./BaseContentCardPaywall');

var _BaseContentCardPaywall2 = _interopRequireDefault(_BaseContentCardPaywall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaseContentCardPaywall2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseContentCardPaywall/index.js
// module id = 257
// module chunks = 11